module.exports = __webpack_public_path__ + "static/media/Liney Arciniegas.4f7b854c.png";